import React from 'react';
import { H4 } from '@xo-union/tk-ui-typography';
import Icon from '@xo-union/tk-component-icons';
import Spinner from '@xo-union/tk-component-spinner';
import styles from './share.scss';

interface Props {
  showSuccess: boolean;
  showError: boolean;
  isSubmitting: boolean;
}

const SendConfirmation: React.FC<Props> = ({ showSuccess, showError, isSubmitting }) => {
  return (
    <div className={`${styles.recaptcha} ${styles.success} ${!showSuccess && !isSubmitting ? styles.hide : ''}`}>
      <div className={styles.recaptchaInner}>
        {!showSuccess && !showError ? (
          <Spinner />
        ) : (
          <div>
            <Icon name={!showError ? 'checkmark_circle' : 'error'} size="md" />
            <H4 className={styles.recaptchaLabel}>
              <strong>{!showError ? 'Message sent!' : 'Something went wrong, please try again'}</strong>
            </H4>
          </div>
        )}
      </div>
    </div>
  );
};

export default SendConfirmation;
